var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-result',{staticClass:"exception-404",attrs:{"status":"404","sub-title":_vm.$t('message.notfound')},scopedSlots:_vm._u([{key:"extra",fn:function(){return [_c('a-button',{attrs:{"type":"primary"},on:{"click":_vm.toHome}},[_vm._v(" "+_vm._s(_vm.$t('message.backHome'))+" ")])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }